import { Typography } from '@mui/material';
import {
  LpFeeCalculationBasis,
  LpFeeCommitmentStatus,
} from 'further-types/lp/lp-fee-template';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Column } from 'further-ui/components/Layout';
import StaticField from 'further-ui/components/StaticField';
import { CalendarDay, numberToCurrencyString } from 'further-ui/utils';
import FeesPreviewAccordion from './FeesPreviewAccordion';

type FeeDetailsForCapitalAction = {
  _id: string;
  feeActionId: string;
  limitedPartner: string;
  feeActionCreatedAt: CalendarDay;
  accrualDate: CalendarDay;
  lpFeeTemplateName: string;
  lpFeeTemplateFeeName: string;
  insideOutsideCommitment: LpFeeCommitmentStatus;
  calculationBasis: LpFeeCalculationBasis;
  feeExTaxLcy: number;
  salesTaxAmountLcy: number;
  feeIncTaxLcy: number;
};

type Props = {
  baseCurrency: CurrencyCode;
  feeActions: Array<{
    id: string;
    accrualDate: CalendarDay;
    feeActionCreatedAt: CalendarDay;
    investorCount: number;
    amountIncVatLcy: number;
    amountExVatLcy: number;
    salesTaxLcy: number;
    fees: Array<FeeDetailsForCapitalAction>;
  }>;
};

const FeeDetails: React.FC<Props> = ({ feeActions, baseCurrency }) => {
  return (
    <Column spacing="lg">
      {feeActions.map((feeAction, index) => (
        <Column key={feeAction.id} spacing="sm">
          <Typography variant="h4">
            Management Fees {index + 1}: Accrual date (
            {feeAction.accrualDate.toLabel()})
          </Typography>
          <Column spacing="sm">
            <StaticField label="Investors" spacing="xxs">
              {feeAction.investorCount}
            </StaticField>
            <StaticField label="Approval date" spacing="xxs">
              {feeAction.feeActionCreatedAt.toLabel()}
            </StaticField>
            <StaticField label="Amount (ex sales tax)" spacing="xxs">
              {numberToCurrencyString(feeAction.amountExVatLcy, {
                currency: baseCurrency,
              })}
            </StaticField>
            <StaticField label="Sales tax" spacing="xxs">
              {numberToCurrencyString(feeAction.salesTaxLcy, {
                currency: baseCurrency,
              })}
            </StaticField>
            <StaticField label="Amount (inc sales tax)" spacing="xxs">
              {numberToCurrencyString(feeAction.amountIncVatLcy, {
                currency: baseCurrency,
              })}
            </StaticField>
          </Column>
          <FeesPreviewAccordion fees={feeAction.fees} />
        </Column>
      ))}
    </Column>
  );
};

export default FeeDetails;
